<template>
  <div>
    <div class="bg-over"></div>
    <div>
      <HeadBar ref="headerBox" class="header-class"></HeadBar>
      <AppMain class="app-class" :style="{'height':'calc('+(height - headerHeight)+'px)'}"></AppMain>
      <!--      <FootBar class="footer-class"></FootBar>-->
    </div>
  </div>
</template>

<script>
import {HeadBar, FootBar, AppMain} from './components'
import HeaderTwo from '@/pages/enterprise/operationAnalysisTwo/headerTwo'

var setIntervalId
var orgtimeOuter = 60 * 3
var timeOuter = orgtimeOuter
export default {
  name: "layout",
  components: {
    HeadBar, FootBar, AppMain, HeaderTwo
  },
  data() {
    return {
      headerNotShow: false,
      width: '1920',
      height: '1080',
      padding: '0',
      isFull: true,
      headerHeight:251,
      style: {
        width: "1440px",
        height: "909px",
        transform: "scale(1) translate(-50%, -50%)",
        padding: 0,
      }
    }
  },
  mounted() {
    this.height = window.innerHeight
    console.log('height', this.height)
    this.style.height = window.innerHeight
    this.setScale();
    window.onresize = this.Debounce(this.setScale, 1000);
    this.getUserInfo()
    window.addEventListener('mousedown', this.handleonmousedown)
    console.log('setIntervalId',setIntervalId)
    if(setIntervalId){
      clearInterval(setIntervalId)
    }
    setIntervalId = setInterval(() => {
      console.log('无操作返回首页',timeOuter)
      if (timeOuter-- <= 0) {
        if (this.$route.path !== '/kejiaohui/home/index') {
          console.log('返回首页')
          // clearInterval(setIntervalId)
          this.$router.push({
            path: '/kejiaohui'
          })
        } else {
          console.log('还在首页')
          this.handleonmousedown()
        }
      }
    }, 1000)

  },
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {
        if (to.matched.some(res => {
          console.log(res.meta)
          return res.meta.headerNotShow
        })) {
          this.headerNotShow = true
        }
        console.log('headerNotShow', this.headerNotShow)
      },
    }
  },
  methods: {
    handleonmousedown() {
      timeOuter = orgtimeOuter
    },
    getUserInfo() {
      this.$store.dispatch('GetUserInfo', 'yygl').then(v => {
      })
    },
    Debounce: (fn, t) => {
      const delay = t || 500;
      let timer;
      return function () {
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // // 获取放大缩小比例
    getScale() {
      const w = window.innerWidth / this.width;
      const h = window.innerHeight / this.height;
      if (this.isFull) {
        return [w, h];
      }
      return w < h ? w : h;
    },
    // // 设置比例
    setScale() {
      this.height = window.innerHeight
    },
  }
}
</script>

<style scoped lang="scss">

.bg-over {
  height: 100vh;
  width: 100vw;
  background: url(../assets/images/common/kejiaohui-bg.png) center/cover;
  position: fixed;
  z-index: -1;
}

.app-class {
  width: 100%;
  display: grid;
  overflow: auto;
}

.footer-class {
  height: 20px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layoutKejiaohui/layout.vue